module.exports = __webpack_public_path__ + "img/cantal.a73773f9.png";